import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin, combineLatest } from 'rxjs';
import { RetailerGroupsService } from './retailer-groups.service';
import { shareReplay, switchMap, map } from 'rxjs/operators';
import { RetailerGroupsMapping } from 'app/types/retailer-groups-types';

@Injectable()
export class RetailerGroupsUtilityService {
    retailerGroupBrandIdMapping: Observable<RetailerGroupsMapping>;
    retailerGroupRetailerMapping: Observable<RetailerGroupsMapping>;

    private brandIds: BehaviorSubject<string[]> = new BehaviorSubject([]);
    private triggerUpdate: BehaviorSubject<void> = new BehaviorSubject<void>(null);

    constructor(private retailerGroupService: RetailerGroupsService) {
        const retailerGroupsArray = combineLatest([this.brandIds, this.triggerUpdate]).pipe(
            switchMap(([brandIds]) =>
                forkJoin(brandIds.map((brandId) => this.retailerGroupService.getRetailerGroups({ _id: brandId }))).pipe(
                    map((data) => brandIds.map((brandId, index) => ({ brandId, groups: data[index] })))
                )
            ),
            shareReplay(1)
        );

        this.retailerGroupBrandIdMapping = retailerGroupsArray.pipe(
            map((data) => data.reduce((acc, { brandId, groups }) => ({ ...acc, [brandId]: groups }), {}))
        );

        this.retailerGroupRetailerMapping = retailerGroupsArray.pipe(
            map((data) => {
                const retailerGroupRetailerMapping = {};
                for (const { brandId, groups } of data) {
                    for (const retailerGroup of groups) {
                        for (const retailer of retailerGroup.retailers) {
                            const retailerGroups =
                                retailerGroupRetailerMapping[this.getRetailerBrandKey(retailer._id, brandId)] || [];
                            retailerGroups.push(retailerGroup);
                            retailerGroupRetailerMapping[this.getRetailerBrandKey(retailer._id, brandId)] =
                                retailerGroups;
                        }
                    }
                }
                return retailerGroupRetailerMapping;
            })
        );
    }

    public setBrandIds(brandIds: string[]): void {
        this.brandIds.next(brandIds);
    }

    public updateRetailerGroups(): void {
        this.triggerUpdate.next();
    }

    public getRetailerBrandKey(retailerId: string, brandId: string) {
        return `${retailerId}-${brandId}`;
    }
}
